import { render, staticRenderFns } from "./dropdowns.vue?vue&type=template&id=5755ce2c&scoped=true"
import script from "./dropdowns.vue?vue&type=script&lang=js"
export * from "./dropdowns.vue?vue&type=script&lang=js"
import style0 from "./dropdowns.vue?vue&type=style&index=0&id=5755ce2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5755ce2c",
  null
  
)

export default component.exports